import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { cva, VariantProps } from 'class-variance-authority';

import { DotComponent } from '../dot/dot.component';

const chipVariants = cva('chip', {
  variants: {
    variant: {
      primary: 'chip--variant-primary',
      secondary: 'chip--variant-secondary',
      accent: 'chip--variant-accent',
      success: 'chip--variant-success',
      disabled: 'chip--variant-disabled',
      compendium: 'chip--variant-compendium',
      ghost: 'chip--variant-ghost',
      published: 'chip--variant-published',
      accepted: 'chip--variant-published',
      approved: 'chip--variant-approved',
      inreview: 'chip--variant-in-review',
      inprogress: 'chip--variant-in-progress',
      pending: 'chip--variant-in-progress',
      inactive: 'chip--variant-inactive',
      denied: 'chip--variant-inactive',
      archived: 'chip--variant-archived',
      ghostDisabled: 'chip--variant-ghost-disabled',
      shared: 'chip--variant-shared',
      changed: 'chip--variant-changed',
    },
    size: {
      default: 'chip--size-default',
      icon: 'chip--size-icon',
      status: 'chip--size-status',
    },
  },
  defaultVariants: {
    variant: 'primary',
    size: 'default',
  },
});
type ChipVariants = VariantProps<typeof chipVariants>;

@Component({
  selector: 'common-chip',
  standalone: true,
  imports: [MatIconModule, DotComponent],
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipComponent {
  public variant = input<ChipVariants['variant']>('primary');
  public size = input<ChipVariants['size']>('default');
  public clickable = input<boolean>(false);
  public customColor = input<string>();
  public customBackgroundColor = input<string>();

  protected computedClass() {
    return chipVariants({ variant: this.variant(), size: this.size() });
  }
}
